import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../../components/common/Title/Title";
import CommissionHistory from "./components/CommissionHistory";
import ListReferralAgent from "./components/ListReferralAgent";
import { Tabs } from "antd";
import WaitingDisbursement from "./components/WaitingDisbursement";
import {
  initDetailCommissionFilterInput,
  initDisburseCommissionFilterInput,
  initListAgentFilterInput,
} from "./constants";
import SwalToast from "../../../../components/helpers/SwalToast";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import Cookies from "js-cookie";
import { convertListAgent } from "./helpers/convertListAgent";
import ModalDetailCommission from "./components/ModalDetailCommission";
import moment from "moment";
import { convertDetailCommission } from "./helpers/convertDetailCommission";
import ModalDisburseCommission from "./components/ModalDisburseCommission";
import { convertNotYetDisbursed } from "./helpers/convertNotYetDisbursed";
import httpclient from "../../../../components/httpclient";
import { convertDisburseCommission } from "./helpers/convertDisburseCommission";
import ModalConfirm from "./components/ModalConfirm";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";
import ModalRejectDisbursement from "./components/ModalRejectDisbursement";
import IsEmpty from "../../../../components/helpers/IsEmpty";

const TabPane = Tabs.TabPane;
export default function CommissionDisbursement() {
  const [tabState, setTabState] = useState("list_agent");
  const [loading, setLoading] = useState(false);
  const [listAgentFilterInput, setListAgentFilterInput] = useState(
    initListAgentFilterInput
  );
  const [listAgenTablePagination, setListAgenTablePagination] = useState({});
  const [listAgenRecords, setListAgenRecords] = useState([]);
  const [listAgentDateValue, setListAgentDateValue] = useState([]);
  const [detailCommission, setDetailCommission] = useState([]);
  const [commissionMasterData, setCommissionMasterData] = useState({});

  const [modalDetailCommission, setModalDetailCommission] = useState(false);
  const [modalDisburseCommission, setModalDisburseCommission] = useState(false);

  const [detailCommissionFilterInput, setDetailCommissionFilterInput] =
    useState(initDetailCommissionFilterInput);
  const [detailCommissionTablePagination, setDetailCommissionTablePagination] =
    useState({});

  const [notYetDisbursedRecords, setNotYetDisbursedRecords] = useState([]);
  const [isCheckAllToDisburse, setIsCheckAllToDisburse] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [disburseRecords, setDisburseRecords] = useState({});
  const [disburseCommissionFilterInput, setDisburseCommissionFilterInput] =
    useState(initDisburseCommissionFilterInput);
  const [historyFilterInput, setHistoryFilterInput] = useState(
    initDisburseCommissionFilterInput
  );
  const [
    disburseCommissionTablePagination,
    setDisburseCommissionTablePagination,
  ] = useState({});
  const [tax, setTax] = useState(0);
  const [feeAdmin, setFeeAdmin] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [dataForModalDisburse, setDataForModalDisburse] = useState();
  const [transferProofImg, setTransferProofImg] = useState([]);
  const [errors, setErrors] = useState({});
  const [uploadData, setUploadData] = useState();
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalReject, setModalReject] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [reasonReject, setReasonReject] = useState("");
  const [errorReject, setErrorReject] = useState(false);
  const [idForReject, setIdForReject] = useState([]);
  const [actionType, setActionType] = useState("");

  const handleTabChange = (key) => {
    setTabState(key);
  };

  useEffect(() => {
    if (tabState === "list_agent") {
      getDataListAgent();
      getCommissionMasterData();
    } else if (tabState === "waiting_disbursement") {
      setDisburseCommissionFilterInput((prev) => ({
        ...prev,
        status: "pending",
        page: 1,
      }));
    } else if (tabState === "commission_history") {
      setDisburseCommissionFilterInput((prev) => ({
        ...prev,
        status: "done",
        page: 1,
      }));
    }
  }, [tabState, listAgentFilterInput]);

  useEffect(() => {
    getDisburseCommission();
  }, [disburseCommissionFilterInput]);

  useEffect(() => {
    getDisburseCommission();
  }, [historyFilterInput]);

  useEffect(() => {
    setTotal(subtotal - (tax + feeAdmin));
  }, [subtotal, tax, feeAdmin, notYetDisbursedRecords]);

  const getDataListAgent = () => {
    setLoading(true);
    let params = {
      search: listAgentFilterInput.search,
      page: parseInt(listAgentFilterInput.page),
      page_size: parseInt(listAgentFilterInput.pageSize),
      start_date: listAgentFilterInput.startDate,
      end_date: listAgentFilterInput.endDate,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/customers`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setListAgenRecords(convertListAgent(response.data.data.items));
        setListAgenTablePagination({
          current: parseInt(response.data.data.page),
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };

  const getCommissionMasterData = () => {
    setLoading(true);
    let params = {
      start_date: listAgentFilterInput.startDate,
      end_date: listAgentFilterInput.endDate,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/master-data`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setCommissionMasterData(response.data.data);
      }
    );
  };

  const getDisburseCommission = () => {
    setLoading(true);
    let params = {};
    if (tabState === "waiting_disbursement") {
      params = {
        page: disburseCommissionFilterInput.page,
        page_size: disburseCommissionFilterInput.pageSize,
        start_date: disburseCommissionFilterInput.startDate,
        end_date: disburseCommissionFilterInput.endDate,
        status: disburseCommissionFilterInput.status,
        search: disburseCommissionFilterInput.search,
      };
    } else if (tabState === "commission_history") {
      params = {
        page: historyFilterInput.page,
        page_size: historyFilterInput.pageSize,
        start_date: historyFilterInput.startDate,
        end_date: historyFilterInput.endDate,
        status: historyFilterInput.status,
        search: historyFilterInput.search,
      };
    }
    console.log(params);
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/disbursements`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setDisburseRecords(
          convertDisburseCommission(response.data.data.items, handleOpenPreview)
        );
        setDisburseCommissionTablePagination({
          current: parseInt(response.data.data.page),
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };

  const getDetailCommission = (id) => {
    setLoading(true);
    let params = {
      page: detailCommissionFilterInput.page,
      page_size: detailCommissionFilterInput.pageSize,
      customer_commission_disbursement_id: id,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/disbursement-detail`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        console.log(response.data.data.items);
        let idCommission = [];
        response.data.data.items.map((item) => {
          idCommission.push(item.customer_commission_id);
        });
        setIdForReject(idCommission);
        setLoading(false);
        setDetailCommission(convertDetailCommission(response.data.data.items));
        setDetailCommissionTablePagination({
          current: parseInt(response.data.data.page),
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };
  const getNoYetDisbursed = (id) => {
    setLoading(true);
    let params = {
      customer_user_id: id,
      start_date: listAgentFilterInput.startDate,
      end_date: listAgentFilterInput.endDate,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/not-yet-disbursed`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setNotYetDisbursedRecords(convertNotYetDisbursed(response.data.data));
      }
    );
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (tabState === "list_agent") {
          if (name === "pageSize") {
            setListAgentFilterInput((prev) => ({
              ...prev,
              [name]: value === "" ? 10 : parseInt(value),
              page: 1,
            }));
          } else {
            setListAgentFilterInput((prev) => ({
              ...prev,
              [name]: value,
              page: 1,
            }));
          }
        } else if (tabState === "waiting_disbursement") {
          if (name === "pageSize") {
            setDisburseCommissionFilterInput((prev) => ({
              ...prev,
              [name]: value === "" ? 10 : parseInt(value),
              page: 1,
            }));
          } else {
            setDisburseCommissionFilterInput((prev) => ({
              ...prev,
              [name]: value,
              page: 1,
            }));
          }
        } else if (tabState === "commission_history") {
          if (name === "pageSize") {
            setListAgentFilterInput((prev) => ({
              ...prev,
              [name]: value === "" ? 10 : parseInt(value),
              page: 1,
            }));
          } else {
            setListAgentFilterInput((prev) => ({
              ...prev,
              [name]: value,
              page: 1,
            }));
          }
        }
      }
    };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    if (tabState === "list_agent") {
      if (name === "pageSize") {
        setListAgentFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      } else {
        setListAgentFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      }
    } else if (tabState === "waiting_disbursement") {
      if (name === "pageSize") {
        setDisburseCommissionFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      } else {
        setDisburseCommissionFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      }
    } else if (tabState === "commission_history") {
      if (name === "pageSize") {
        setHistoryFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      } else {
        setHistoryFilterInput((prev) => ({
          ...prev,
          [name]: value,
          page: 1,
        }));
      }
    }
  };

  const handleProcessButton = (record, type) => {
    setModalDisburseCommission(true);
    getNoYetDisbursed(record.id);
    setDataForModalDisburse(record);
    setActionType(type);
  };
  const handleDetailAgentButton = (record) => {
    setModalDetailCommission(true);
    getDetailCommission(record.id);
  };

  const handleDisbursementButton = (record) => {
    setModalDetailCommission(true);
    getDetailCommission(record.id);
    setDataForModalDisburse(record);
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");
    console.log(moment(startDate).format());
    console.log(moment(endDate).format());

    if (tabState === "list_agent") {
      setListAgentDateValue(event ? [startDate, endDate] : null);
      setListAgentFilterInput((prev) => ({
        ...prev,
        startDate: event ? moment(startDate).format() : null,
        endDate: event ? moment(endDate).format() : null,
        page: 1,
      }));
    } else if (tabState === "waiting_disbursement") {
      setDisburseCommissionFilterInput((prev) => ({
        ...prev,
        startDate: event ? moment(startDate).format() : null,
        endDate: event ? moment(endDate).format() : null,
        page: 1,
      }));
    } else if (tabState === "commission_history") {
      setHistoryFilterInput((prev) => ({
        ...prev,
        startDate: event ? moment(startDate).format() : null,
        endDate: event ? moment(endDate).format() : null,
        page: 1,
      }));
    }
  };

  const handleTableChange = (pagination, _, sorter) => {
    if (tabState === "list_agent") {
      setListAgentFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
      }));
    } else if (tabState === "waiting_disbursement") {
      setDisburseCommissionFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
      }));
    } else if (tabState === "commission_history") {
      setHistoryFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
      }));
    }
  };

  const handleTableChangeModal = (pagination, _, sorter) => {
    setDetailCommissionFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const onCheck = (record) => {
    let temp = [...notYetDisbursedRecords];
    let amount = 0;
    temp.find((value) => value.id === record.id).is_checked = !temp.find(
      (value) => value.id === record.id
    ).is_checked;
    setNotYetDisbursedRecords(temp);
    setSubtotal(countSubtotal(temp));
  };

  const onCheckAll = () => {
    setIsCheckAllToDisburse(!isCheckAllToDisburse);
    let temp = [...notYetDisbursedRecords];
    temp.forEach((value) => {
      value.is_checked = !isCheckAllToDisburse;
    });
    setNotYetDisbursedRecords(temp);
    setSubtotal(countSubtotal(temp));
  };

  const countSubtotal = (data) => {
    let total = 0;
    data.forEach(function (item) {
      if (item.is_checked) {
        total += item.commissionNumber;
      }
    });
    return total;
  };

  const handleCloseModalDisburse = () => {
    setModalDisburseCommission(false);
    setIsCheckAllToDisburse(false);
    setSubtotal(0);
    setTax(0);
    setFeeAdmin(0);
    setNotYetDisbursedRecords([]);
    setActionType("");
    setReasonReject("");
  };

  const handleCloseModalDetail = () => {
    setModalDetailCommission(false);
    setDataForModalDisburse();
    setUploadData();
    setTransferProofImg([]);
    setReasonReject("");
  };

  const onProcess = () => {
    let tempID = [];
    notYetDisbursedRecords.forEach(
      (value) => value.is_checked && tempID.push(value.id)
    );
    if (tempID.length > 0) {
      setSubmitting(true);
      let data = {
        customer_commission_ids: tempID,
        tax_amount: tax,
        admin_fee: feeAdmin,
      };
      // console.log(data);
      let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/new`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getDataListAgent();
          getCommissionMasterData();
          setModalDisburseCommission(false);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      SwalToast.fire({
        icon: "error",
        title: "Belum memilih transaksi",
      });
    }
  };

  const onDisburse = () => {
    setSubmitting(true);
    let data = {
      customer_commission_disbursement_id: dataForModalDisburse.id,
      proof: uploadData.transferProof,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/mark-as-done`;
    httpclient
      .POST(url, data)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        getDisburseCommission();
        setModalConfirm(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleReject = () => {
    if (actionType === "reject") {
      let tempID = [];
      notYetDisbursedRecords.forEach(
        (value) => value.is_checked && tempID.push(value.id)
      );
      if (tempID.length > 0) {
        setModalReject(true);
      } else {
        SwalToast.fire({
          icon: "error",
          title: "Belum memilih transaksi",
        });
      }
    } else {
      setModalReject(true);
    }
  };

  const openConfirmDialog = () => {
    setModalDetailCommission(false);
    setModalConfirm(true);
  };

  const handleImageChange =
    (type) =>
    ({ fileList }) => {
      let tempFileList = [...fileList];
      tempFileList = tempFileList.slice(-1);

      tempFileList = tempFileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
          file.name = "tes";
        }
        return file;
      });
      setTransferProofImg(tempFileList);
      if (errors[type]) {
        setErrors((prev) => ({
          ...prev,
          [type]: null,
        }));
      }
    };

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setUploadData((prev) => ({
          ...prev,
          transferProof:
            type === "transferProof"
              ? response.data.data.object_path
              : prev.transferProof,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const onCloseModalConfirm = () => {
    setModalConfirm(false);
    setUploadData();
    setModalReject(false);
    setReasonReject("");
  };

  const onReject = () => {
    setErrorReject(false);
    if (IsEmpty(reasonReject)) {
      setErrorReject(true);
    } else {
      let tempID = [];
      notYetDisbursedRecords.forEach(
        (value) => value.is_checked && tempID.push(value.id)
      );
      let data = {
        customer_commission_ids: actionType === "reject" ? tempID : idForReject,
        notes: reasonReject,
      };
      console.log(data);
      setSubmitting(true);
      let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/commission/cancel`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getDataListAgent();
          getCommissionMasterData();
          getDisburseCommission();
          setModalReject(false);
          handleCloseModalDetail();
          handleCloseModalDisburse();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };
  return (
    <div>
      <div className="px-3">
        <div className="py-4">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pencairan Komisi"} />
            <Breadcrumb current={"Pencairan Komisi"} />
          </div>
        </div>
        <Tabs defaultActiveKey="list_agent" onChange={handleTabChange}>
          <TabPane tab="Daftar Referral/Agen" key="list_agent">
            <ListReferralAgent
              handleEnter={handleEnter}
              loading={loading}
              data={listAgenRecords}
              tablePagination={listAgenTablePagination}
              handleProcessButton={handleProcessButton}
              commissionMasterData={commissionMasterData}
              filterInput={listAgentFilterInput}
              handleInputChange={handleTextInputChange}
              handleDateChange={handleDateChange}
              handleTableChange={handleTableChange}
            />
          </TabPane>
          <TabPane tab="Menunggu Pencairan" key="waiting_disbursement">
            <WaitingDisbursement
              handleEnter={handleEnter}
              loading={loading}
              data={disburseRecords}
              tablePagination={disburseCommissionTablePagination}
              filterInput={disburseCommissionFilterInput}
              handleInputChange={handleTextInputChange}
              handleDateChange={handleDateChange}
              handleTableChange={handleTableChange}
              handleDetailAgentButton={handleDetailAgentButton}
              handleDisbursementButton={handleDisbursementButton}
            />
          </TabPane>
          <TabPane tab="Riwayat Pencairan Komisi" key="commission_history">
            <CommissionHistory
              handleEnter={handleEnter}
              loading={loading}
              data={disburseRecords}
              tablePagination={disburseCommissionTablePagination}
              filterInput={historyFilterInput}
              handleInputChange={handleTextInputChange}
              handleDateChange={handleDateChange}
              handleTableChange={handleTableChange}
              handleDetailAgentButton={handleDetailAgentButton}
            />
          </TabPane>
        </Tabs>
      </div>

      <ModalRejectDisbursement
        visible={modalReject}
        submitting={submitting}
        onReject={onReject}
        onClose={onCloseModalConfirm}
        reasonReject={reasonReject}
        setReasonReject={setReasonReject}
        errorReject={errorReject}
        name={dataForModalDisburse?.customerName}
      />
      <ModalDetailCommission
        visible={modalDetailCommission}
        data={detailCommission}
        loading={loading}
        handleTableChange={handleTableChangeModal}
        tablePagination={detailCommissionTablePagination}
        onClose={handleCloseModalDetail}
        dataForModalDisburse={dataForModalDisburse}
        handleImageChange={handleImageChange}
        handleUploadImage={handleUploadImage}
        transferProofImg={transferProofImg}
        errors={errors}
        uploadData={uploadData}
        openConfirmDialog={openConfirmDialog}
        handleReject={handleReject}
      />
      <ModalDisburseCommission
        visible={modalDisburseCommission}
        data={notYetDisbursedRecords}
        loading={loading}
        onCheck={onCheck}
        onCheckAll={onCheckAll}
        isAllChecked={isCheckAllToDisburse}
        handleCloseModalDisburse={handleCloseModalDisburse}
        onSubmit={onProcess}
        submitting={submitting}
        tax={tax}
        setTax={setTax}
        feeAdmin={feeAdmin}
        setFeeAdmin={setFeeAdmin}
        subtotal={subtotal}
        total={total}
        actionType={actionType}
        handleReject={handleReject}
      />
      <ModalConfirm
        visible={modalConfirm}
        setModalConfirm={setModalConfirm}
        submitting={submitting}
        onDisburse={onDisburse}
        dataForModalDisburse={dataForModalDisburse}
        onClose={onCloseModalConfirm}
      />
      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </div>
  );
}
